export const execJS = function(data) {
	const regDetectJs = /<script(.|\n)*?>(.|\n|\r\n)*?<\/script>/gi;
	const jsContained = data.match(regDetectJs);
	if (jsContained) {
		const regGetJS = /<script(.|\n)*?>((.|\n|\r\n)*)?<\/script>/im;
		const jsNums = jsContained.length;
		for (let i = 0; i < jsNums; i++) {
			const jsSection = jsContained[i].match(regGetJS);

			if (jsSection[2]) {
				if (window.execScript) {
					//IE
					window.execScript(jsSection[2]);
				} else {
					window.eval(jsSection[2]);
				}
			}
		}
	}
};